import loadable from '@loadable/component';
import React from 'react';

const LoadableComponent = loadable(() =>
  import(/* webpackChunkName: "campaigns" */ './campaign-banner')
);
const CampaignBannerLoader = props => <LoadableComponent {...props} />;

export default CampaignBannerLoader;
